import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loginAction } from "../../store/user/userThunk";
import { ImSpinner8 } from "react-icons/im";
import { toast } from "react-toastify";
import { reset } from "store/lead/leadSlice";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [userRole, setUserRole] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const { user } = useSelector((state) => state.user);

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate email and password before dispatching the action
    if (!email || !password) {
      toast.error("Please enter both email and password");
      return;
    }
    // navigate("/admin/worker");
    setLoader(true); // Start loader
    dispatch(
      loginAction({
        Email: email,
        Password: password,
        onSuccess: () => {
          dispatch(reset());
          setLoader(false); // Stop loader on success
          navigate("/admin/worker");
        },
        onError: (error, response) => {
          setLoader(false); // Stop loader on error
          console.error(error);
          toast.error(error);
        },
      })
    );
  };

  const handleForgetPassword = (e) => {
    e.preventDefault();
    navigate("/auth/forgotPassword");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-900">
      <div className="w-[60%] lg:w-[50%] xl:w-4/12 2xl:w-[500px] px-4">
        <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-200 border-0">
          <div className="rounded-t mb-0 px-6 py-6">
            <div className="text-center mb-3">
              <h6 className="text-blueGray-500 text-sm font-bold">Sign in</h6>
            </div>
            <hr className="mt-6 border-b-1 border-blueGray-300" />
          </div>
          <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
            <form onSubmit={handleSubmit}>
              <div className="relative w-full mb-3">
                <label
                  className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                  htmlFor="grid-email"
                >
                  Email
                </label>
                <input
                  type="email"
                  className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={loader} // Disable input when loader is active
                />
              </div>

              <div className="relative w-full mb-3">
                <label
                  className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                  htmlFor="grid-password"
                >
                  Password
                </label>
                <input
                  type="password"
                  className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  disabled={loader} // Disable input when loader is active
                />
              </div>

              <div className="text-center mt-6">
                <button
                  className="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all duration-150"
                  type="submit"
                  disabled={loader} // Disable button when loader is active
                >
                  {loader ? <ImSpinner8 className="spinning-icon" /> : "Log in"}
                </button>
              </div>

              <div className="justify-end w-full flex">
                <button onClick={handleForgetPassword}>Forgot password</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

// const handleSubmit = (e) => {
//   e.preventDefault();

//   if (!email || !password) {
//     toast.error("Please enter both email and password");
//     return;
//   }

//   setLoader(true); // Start loader

//   // Simulate backend response
//   setTimeout(() => {
//     setLoader(false); // Stop loader
//     if (email === "admin88@gmail.com" && password === "12345678") {
//       const hardcodedResponse = {
//         details: {
//           AccessToken: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJmcmVzaCI6ZmFsc2UsImlhdCI6MTczMTkyNTI2MywianRpIjoiZGY4OWI2YjgtZGI3ZC00MDdkLWE3Y2QtODMxZDYwNGNiYjE0IiwidHlwZSI6ImFjY2VzcyIsInN1YiI6ImFkbWluODhAZ21haWwuY29tIiwibmJmIjoxNzMxOTI1MjYzLCJjc3JmIjoiNjczZGIxMGUtYmZmNi00MDJiLTljNzEtMjQ5ODA0OGViZTlhIn0.8ZXd4zi0WYKHrEVs5c-PB1v-w_dMpgd5S4QtBC-L9Jw",
//           User: {
//             Email: "admin88@gmail.com",
//             Role: "Admin", // Hardcoded role
//             isActive: true,
//           },
//         },
//       };
//       setUserRole(hardcodedResponse.details.User.Role); // Set user role
//       navigate("/admin/worker")
//       toast.success(`Logged in as ${hardcodedResponse.details.User.Role}`);
//     } else if (email === "teamlead@gmail.com" && password === "12345678") {
//       const hardcodedResponse = {
//         details: {
//           AccessToken: "dummy-token-for-now",
//           User: {
//             Email: "teamlead@gmail.com",
//             Role: "TeamLead", // Hardcoded role
//             isActive: true,
//           },
//         },
//       };
//       setUserRole(hardcodedResponse.details.User.Role); // Set user role
//       localStorage.setItem("userRole", "TeamLead");
//       toast.success(`Logged in as ${hardcodedResponse.details.User.Role}`);
//       navigate("/admin/worker")
//     }
//     else if (email === "agent@gmail.com" && password === "12345678") {
//       const hardcodedResponse = {
//         details: {
//           AccessToken: "dummy-token-for-now",
//           User: {
//             Email: "agent@gmail.com",
//             Role: "Agent", // Hardcoded role
//             isActive: true,
//           },
//         },
//       };
//       setUserRole(hardcodedResponse.details.User.Role); // Set user role
//       localStorage.setItem("userRole", "Agent");
//       toast.success(`Logged in as ${hardcodedResponse.details.User.Role}`);
//       navigate("/admin/worker")
//     }

//     else {
//       toast.error("Invalid email or password");
//     }
//   }, 1000); // Simulate network delay
// };
